const RUNTIME_AGENT_FIELDS = [
  "position",
  "targetPosition",
  "state",
  "currentTask",
  "currentZoneId",
  "mode",
  "activity",
  "locationTag",
]

function cloneRuntimeValue(value) {
  return Array.isArray(value) ? [...value] : value
}

export function preserveAgentRuntimeFields(bootstrapAgent, currentAgent) {
  if (!bootstrapAgent || !currentAgent) return bootstrapAgent

  const nextAgent = { ...bootstrapAgent }
  for (const field of RUNTIME_AGENT_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(currentAgent, field)) {
      nextAgent[field] = cloneRuntimeValue(currentAgent[field])
    }
  }
  return nextAgent
}

export function resolveBootstrapUiState({
  currentState,
  worldState,
  preserveRuntime = false,
}) {
  const activeView =
    typeof worldState?.active_view === "string" && worldState.active_view
      ? worldState.active_view
      : currentState.activeView
  const selectedAgentId =
    typeof worldState?.selected_agent_id === "string" &&
    worldState.selected_agent_id
      ? worldState.selected_agent_id
      : null
  const mapZoomTarget =
    typeof worldState?.map_zoom_target === "string"
      ? worldState.map_zoom_target
      : null

  if (!preserveRuntime) {
    return {
      activeView,
      selectedAgentId,
      mapZoomTarget,
    }
  }

  return {
    activeView: currentState.activeView || activeView,
    selectedAgentId: currentState.selectedAgentId ?? null,
    mapZoomTarget: currentState.mapZoomTarget ?? null,
  }
}

